import EvmTransaction from './EvmTransaction.js';
import SolanaTransaction from './SolanaTransaction.js';
import ExodusTransaction from './ExodusTransaction.js';
export function fromJSON(json) {
    if (json.type === 'evm') {
        return new EvmTransaction(json);
    }
    if (json.type === 'solana') {
        return new SolanaTransaction(json);
    }
    return new ExodusTransaction(json);
}
